import { Action, getModule, Module, Mutation, MutationAction, VuexModule } from 'vuex-module-decorators'
import store from '@/store'
import { ResponseDataType } from "@/form/form.types"
import { Manager, IManager } from "@/entity/manager/manager.types"
import { PaginationRequestType } from "@/entity/common/pagination.types"
import { IStoreReady } from '@/store/lib/storeSupport'
import { prepareFormData } from "@/store/utils/formDataHelper";
@Module({
    namespaced: true,
    name: 'manager',
    store,
    dynamic: true,
})
class ManagerModule extends VuexModule implements IStoreReady{
    manager: IManager[] = []
    managerLoaded = false
    ready = false

    @Mutation
    async setReady(st:boolean){
        this.ready = st
    }

    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ manager: any; managerLoaded: boolean }> {
        let managerLoaded = false;
        const manager = await store.$repository.manager.fetchAll(prepareFormData(data));
        if (manager) {
            managerLoaded = true;
        }
        return {manager, managerLoaded};
    }
    @Action({rawError: true})
    async delete(id: number): Promise<ResponseDataType> {
        const resp = await store.$repository.manager.delete({id: id});
        return resp;
    }
}

export const ManagerStore = getModule(ManagerModule);
